module.exports = __webpack_public_path__ + "d3b47375afd904983d9be8d6e239a949.woff";